import { ADD_EMAIL_INTEGRATION, ADD_EMAIL_INTEGRATION_FAILED, ADD_EMAIL_INTEGRATION_SUCCESS,GET_EMAIL_INTEGRATION,GET_EMAIL_INTEGRATION_SUCCESS,GET_EMAIL_INTEGRATION_FAILED ,GET_EMAIL_TEST,GET_EMAIL_TEST_SUCCESS,GET_EMAIL_TEST_FAILED} from "./actionTypes"


export const addEmailIntegration = (data) => {
  return {
    type: ADD_EMAIL_INTEGRATION,
    payload:data ,
  }
}

export const  addEmailIntegrationSuccess = message => {
  return {
    type: ADD_EMAIL_INTEGRATION_SUCCESS,
    payload: message,
  }
}

export const  addEmailIntegrationFailed = message => {
  return {
    type: ADD_EMAIL_INTEGRATION_FAILED,
    payload: message,
  }
}

export const getEmailIntegration = (data) => {
  return {
    type: GET_EMAIL_INTEGRATION,
    payload:data ,
  }
}

export const  getEmailIntegrationSuccess = (data) => {
  return {
    type: GET_EMAIL_INTEGRATION_SUCCESS,
    payload: data,
  }
}

export const  getEmailIntegrationFailed = (data) => {
  return {
    type: GET_EMAIL_INTEGRATION_FAILED,
    payload: data,
  }
}

export const getEmailTest = (data) => {
  return {
    type: GET_EMAIL_TEST,
    payload:data ,
  }
}

export const  getEmailTestSuccess = (data) => {
  return {
    type: GET_EMAIL_TEST_SUCCESS,
    payload: data,
  }
}

export const  getEmailTestFailed = (data) => {
  return {
    type: GET_EMAIL_TEST_FAILED,
    payload: data,
  }
}

